var portfolioPositionsList = {
	caption: "Portfolio positions",
	name: "Naam",
	isin: "ISIN",
	numberOfShares: "Hoeveelheid/Nominaal",
	price: "Laatste Prijs",
	dateTime: "Tijd/Datum",
	todayChange: "Verandering vandaag",
	unrealizedPerformance: "Ongerealiseerde prestatie.",
	marketValue: "Marktwaarde",
	purchaseValue: "Aankoopwaarde",
	weight: "Belang%",
	actions: "Acties",
	noPositions: "Geen Posities.",
	averagePurchasePrice: "Gemiddelde koopprijs"
};
var nl = {
	portfolioPositionsList: portfolioPositionsList
};

export { nl as default, portfolioPositionsList };
